import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@mui/styles';
import {
	colors, Button, Grid, Card, CardContent, CardHeader,
	Divider, Paper, Input,
	Grid2, Checkbox, FormControlLabel, Tooltip

} from '@mui/material';
import { Page, Header, Alert, FilePicker, FilesDropzone } from 'components';
import { enqueueSnackbar } from 'actions';
import ModalDialog from '../../../../components/ModalDialog/ModalDialog.js';
import {
	SetFormState, UploadFileUpdateSitesSiteTracker,
	FileUpdateSitesCommitSiteTracker
} from '../../actions/SiteTrackerActions.js';

const useStyles = makeStyles((theme) => ({
	root: {
		width: 960,
	},
	header: {
		padding: theme.spacing(3),
		maxWidth: 720,
		margin: '0 auto',
	},
	content: {
		padding: theme.spacing(0, 2),
		maxWidth: 720,
		margin: '0 auto',
	},
	helperText: {
		textAlign: 'right',
		marginRight: 0,
	},
	author: {
		margin: theme.spacing(4, 0),
		display: 'flex',
	},
	avatar: {
		marginRight: theme.spacing(2),
	},
	actions: {
		backgroundColor: colors.grey[100],
		padding: theme.spacing(2),
		display: 'flex',
		alignContent: 'right',
	},
	applyButton: {
		color: theme.palette.white,
		backgroundColor: colors.green[600],
		'&:hover': {
			backgroundColor: colors.green[900],
		},
	},
}));

const SiteTrackerFileUpdateSitesDialog = (props) => {
	const { author, open, onClose, onApply, className, ...rest } = props;
	const classes = useStyles();
	const dispatch = useDispatch();
	const setFormState = formState => dispatch(SetFormState(formState));
	const formState = useSelector((state) => state.siteTrackerReducer.formState);
	const userId = useSelector(state => state.session.user.id);
	const fileUpdateSitesMessage = useSelector((state) => state.siteTrackerReducer.fileUpdateSitesMessage);

	const _onChangeInput = (event) => {
		if (event.target.files[0].type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
			if (event.target.files && event.target.files.length > 0) {
				const file = event.target.files[0];
				setFormState({
					...formState,
					values: {
						...formState.values,
						inputFileUpdatePath: file
					}
				});
			}
		} else {
			dispatch(enqueueSnackbar({ message: 'File type not supported', options: { variant: 'warning' } }));
		}
	};

	const _onConfirmClick = (event) => {
		if (formState.values.inputFileUpdatePath) {
			if (formState.values.inputFileUpdatePath.size > 100000000) {
				dispatch(enqueueSnackbar({ message: 'File size cannot be superior to 100MB', options: { variant: 'warning' } }));
			} else if (formState.values.inputFileUpdatePath === '') {
				dispatch(enqueueSnackbar({ message: 'No file selected', options: { variant: 'Info' } }));
			} else {
				dispatch(UploadFileUpdateSitesSiteTracker(userId, formState.values.inputFileUpdatePath));
			}
		}
	};

	const _onCommitChanges = (event) => {
		dispatch(FileUpdateSitesCommitSiteTracker(userId, checked));
	};

	const [checked, setChecked] = React.useState(false);

	const handleChange = (event) => {
		setChecked(event.target.checked);
	};

	console.log(checked);

	return (
		<ModalDialog
			// maxWidth="xs"
			onClose={onClose}
			open={open}
			title="File Update Sites"
			confirmLabel="Upload"
			hasConfirm={false}
		// onConfirmClicked={_onConfirmClick}
		>
			<div className={classes.fields}>
				<br />
				<Card className={classes.container} container spacing={3}>
					{/* <CardHeader title="Import Site Tracker" /> */}
					<Divider />
					<CardContent>
						<Grid2 container spacing={1}>
							<Grid2 size={8}>
								<FilePicker
									placeholder="Please select a xlsx to upload"
									accept=".xlsx"
									onChange={_onChangeInput}
									value={formState.values.inputFileUpdatePath?.name || ''}
								/>
							</Grid2>
							<Grid2 size={2}>
								<Button
									onClick={_onConfirmClick}
									color="secondary"
									size="small"
									variant="contained"
									fullWidth
									sx={'height:100%'}
								>
									Upload
								</Button>
							</Grid2>
							<Grid2 size={2}>
								<Tooltip title="Update Proximities (Forecast Date and Status) based on MOCN (Sheduled)">
									<FormControlLabel
										control={<Checkbox checked={checked} onChange={handleChange} />}
										label="Update Proximities"
									/>
								</Tooltip>
							</Grid2>
						</Grid2>
					</CardContent>
				</Card>
				<br />
				<Card className={classes.container} container spacing={3} hidden={fileUpdateSitesMessage !== ''}>
					{/* <CardHeader title="Import Site Tracker" /> */}
					<Divider />
					<CardContent>
						<Grid2>
							<img
								src="./images/gifs/FileUpdateSites.gif"
								alt="loading"
							// style={{ width: 33, height: 33, verticalAlign: 'middle', marginRight: 8 }}
							/>
						</Grid2>
					</CardContent>
				</Card>
				<Card className={classes.container} container spacing={3} hidden={fileUpdateSitesMessage === ''}>
					{/* <CardHeader title="Import Site Tracker" /> */}
					<Divider />
					<CardContent>
						<Input
							value={fileUpdateSitesMessage}
							className={classes.input}
							disableUnderline
							// onChange={_handleCommentInputChange}
							// placeholder="Type a comment"
							fullWidth
							multiline
						/>
						<Grid2 hidden={fileUpdateSitesMessage === ''}>
							<Button
								onClick={_onCommitChanges}
								color="secondary"
								size="small"
								variant="contained"
							>
								Commit Changes
							</Button>
						</Grid2>
					</CardContent>
				</Card>
			</div>

		</ModalDialog>
	);
};

SiteTrackerFileUpdateSitesDialog.propTypes = {
	author: PropTypes.object,
	className: PropTypes.string,
	onApply: PropTypes.func,
	onClose: PropTypes.func,
	open: PropTypes.bool,
	tableId: PropTypes.string,
	title: PropTypes.string
};

export default SiteTrackerFileUpdateSitesDialog;
